import React from 'react'
import { usePaymentMethodAction } from '../hooks/useCheckoutAction'
import { BusyButton } from '@ztechapps/webui.button'
import { Icon } from '@ztechapps/webui.util'
import { useCheckoutContext } from '../index'
import { useOrderShippingRates } from '../hooks/useOrderShippingRates'
export const PaymentMethodButton = () => {
  const [onClickPaymentMethod] = usePaymentMethodAction()
  const context = useCheckoutContext()
  const [showLoadingOverlay] = context.showLoadingOverlay
  const [shippingOptions] = context.shippingOptions
  const isManualShippingRate = shippingOptions?.isManualShippingRate
  const { document } = context.orderDocumentResult
  const [, orderShippingRateList] = useOrderShippingRates()

  const disabled =
    isManualShippingRate || document?.shipping?.shipmentId
      ? false
      : orderShippingRateList.loading || !shippingOptions.carrierRate?.hasSelected

  return (
    <BusyButton
      isBusy={showLoadingOverlay}
      onClick={onClickPaymentMethod}
      disabled={disabled}
      busyText="Validating shipment..."
      text="Choose Payment Method"
    >
      <Icon name="chevron-right" />
    </BusyButton>
  )
}
